/*
 * Oath — FAQ sticky tab nav (FAQ PAGE only).
 * ... (header comment unchanged) ...
 */
(function () {
  'use strict';

  // Decorative emblem shown on the ACTIVE tab only (Figma 1010:6973).
  // ▼▼▼ REPLACE the inner markup with your real brand emblem SVG ▼▼▼
  // Keep the class + aria-hidden/focusable attributes. Use fill/stroke
  // "currentColor" so the gold is controlled from CSS (.oath-faq-tab-nav__icon).
var ICON_SVG =
  '<svg class="oath-faq-tab-nav__icon" xmlns="http://www.w3.org/2000/svg" width="15" height="15" viewBox="0 0 15 15" fill="none" aria-hidden="true" focusable="false">' +
    '<path d="M8.06081 1.16331C11.5648 0.844469 14.6622 3.43016 14.9745 6.93471C15.2868 10.4393 12.6953 13.5319 9.19019 13.8376C5.69431 14.1425 2.61162 11.5594 2.30016 8.06409C1.9887 4.5688 4.56609 1.48128 8.06081 1.16331ZM6.58431 9.77625C7.41052 10.204 7.42247 9.72567 8.03394 9.42817C8.08664 8.75354 7.94761 5.67171 8.12065 5.28864C8.25493 4.99132 8.73764 4.57886 8.99812 4.35787C9.01697 4.34193 9.03609 4.32637 9.05547 4.31113C9.26429 5.35328 9.20745 6.59063 9.20456 7.66219C9.20378 8.65066 9.2218 9.63907 9.25856 10.6269C9.28222 11.1533 9.32898 11.6997 9.36632 12.2271C9.38842 12.5388 9.38336 13.2999 9.46078 13.5737C11.0237 13.4227 11.9945 12.8193 12.7786 11.4152C14.2317 8.81274 13.3402 4.58748 10.9947 2.69161C10.6215 2.89635 10.1363 3.0151 9.7907 3.24604C8.53811 4.08319 7.59883 5.1733 6.96614 6.54085C6.82306 6.85011 6.59668 7.25259 6.51848 7.57698C6.34052 8.31534 6.21509 9.09002 6.58431 9.77625ZM7.74373 1.4335C6.69062 1.50771 5.81689 1.87109 5.11162 2.67093C4.94948 2.85484 4.82613 3.02806 4.65338 3.20943C5.07023 3.12648 5.49209 3.0483 5.90762 2.97325C6.6901 2.83194 6.99457 2.604 7.78761 2.76414C8.1828 2.88027 8.53718 3.06129 8.80457 3.39708C8.8645 3.4723 8.86606 3.49677 8.9497 3.51869C9.07386 3.4601 9.08971 3.33617 9.21509 3.25492C9.60343 3.00327 10.1273 2.5782 10.5182 2.36392C9.81294 1.81061 8.63002 1.40929 7.74373 1.4335ZM7.15928 3.02054C6.29532 3.17652 5.64951 3.62166 4.8943 4.05766C4.65245 4.19729 4.36673 4.4403 4.11297 4.54228C3.8337 4.95522 3.84278 5.53205 3.79616 6.01684C3.52117 8.87677 5.12542 12.1112 7.83041 13.2507C7.90633 13.2827 8.08285 13.3171 8.17184 13.3375C8.12849 13.1002 8.12675 12.8678 8.12961 12.6267C8.08976 11.6699 8.09699 10.6927 8.07671 9.73336C7.80091 10.0252 7.61792 10.369 7.30262 10.6121C6.20233 11.4602 5.10769 10.8052 5.15474 9.45793C5.22283 7.50856 6.79547 6.02014 7.93216 4.59095C8.07359 4.41386 7.85375 3.25362 7.67279 3.06595C7.62484 3.00764 7.50478 3.00478 7.43042 3.007C7.33998 3.01016 7.24957 3.01467 7.15928 3.02054Z" fill="#EDC267"/>' +
  '</svg>';
  // ▲▲▲ REPLACE ▲▲▲

  function makeIcon() {
    var tpl = document.createElement('template');
    tpl.innerHTML = ICON_SVG.trim();
    return tpl.content.firstElementChild;
  }

  function init() {
    var nav = document.querySelector('[data-faq-tab-nav]');
    var list = nav && nav.querySelector('[data-faq-tab-list]');
    if (!nav || !list) return;

    var sections = Array.prototype.slice
      .call(document.querySelectorAll('.shopify-section'))
      .filter(function (s) { return s.querySelector('.accordion'); });

    if (!sections.length) {
      nav.hidden = true;
      return;
    }

    var tabsById = {};
    sections.forEach(function (sec) {
      if (!sec.id) return;
      var headingEl = sec.querySelector('h1, h2, h3, h4, h5, h6');
      var title = headingEl ? headingEl.textContent.trim() : '';
      if (!title) return;

      var li = document.createElement('li');
      li.className = 'oath-faq-tab-nav__item';

      var a = document.createElement('a');
      a.className = 'oath-faq-tab-nav__tab';
      a.href = '#' + sec.id;
      a.setAttribute('data-faq-tab-for', sec.id);

      // icon (hidden until active via CSS) + label wrapper
      var icon = makeIcon();
      if (icon) a.appendChild(icon);
      var label = document.createElement('span');
      label.className = 'oath-faq-tab-nav__label';
      label.textContent = title;
      a.appendChild(label);

      li.appendChild(a);
      list.appendChild(li);
      tabsById[sec.id] = a;

      a.addEventListener('click', function (e) {
        e.preventDefault();
        scrollToSection(sec);
        setActive(sec.id);
        if (window.history && window.history.replaceState) {
          window.history.replaceState(null, '', '#' + sec.id);
        }
      });
    });

    function navOffset() {
      return Math.ceil(nav.getBoundingClientRect().height) || 0;
    }

    function scrollToSection(sec) {
      var top = sec.getBoundingClientRect().top + window.pageYOffset - navOffset();
      window.scrollTo({ top: top, behavior: 'smooth' });
    }

    function setActive(id) {
      Object.keys(tabsById).forEach(function (key) {
        var on = key === id;
        tabsById[key].classList.toggle('is-active', on);
        if (on) {
          tabsById[key].setAttribute('aria-current', 'true');
        } else {
          tabsById[key].removeAttribute('aria-current');
        }
      });
    }

    if ('IntersectionObserver' in window) {
      var io = new IntersectionObserver(
        function (entries) {
          entries.forEach(function (entry) {
            if (entry.isIntersecting && tabsById[entry.target.id]) {
              setActive(entry.target.id);
            }
          });
        },
        { rootMargin: '-' + (navOffset() + 8) + 'px 0px -55% 0px', threshold: 0 }
      );
      sections.forEach(function (sec) { io.observe(sec); });
    }

    // --- JS-driven sticky (unchanged) --------------------------------------
    var placeholder = document.createElement('div');
    placeholder.setAttribute('aria-hidden', 'true');
    placeholder.className = 'oath-faq-tab-nav__placeholder';
    placeholder.style.display = 'none';
    nav.parentNode.insertBefore(placeholder, nav);

    var stuck = false;
    var ticking = false;
    var lastSection = sections[sections.length - 1];

    function slotTop() {
      var ref = stuck ? placeholder : nav;
      return ref.getBoundingClientRect().top + window.pageYOffset;
    }

    function applyStuck() {
      var rect = nav.getBoundingClientRect();
      placeholder.style.height = rect.height + 'px';
      placeholder.style.display = 'block';
      nav.style.position = 'fixed';
      nav.style.top = '0';
      nav.style.left = rect.left + 'px';
      nav.style.width = rect.width + 'px';
      nav.classList.add('is-stuck');
      stuck = true;
    }

    function releaseStuck() {
      nav.style.position = '';
      nav.style.top = '';
      nav.style.left = '';
      nav.style.width = '';
      nav.classList.remove('is-stuck');
      placeholder.style.display = 'none';
      stuck = false;
    }

    function updateSticky() {
      ticking = false;
      var navH = nav.offsetHeight;
      var triggerY = slotTop();
      var endY = lastSection.getBoundingClientRect().bottom + window.pageYOffset - navH;
      var y = window.pageYOffset;
      var shouldStick = y >= triggerY && y < endY;

      if (shouldStick && !stuck) {
        applyStuck();
      } else if (!shouldStick && stuck) {
        releaseStuck();
      } else if (stuck) {
        var pr = placeholder.getBoundingClientRect();
        nav.style.left = pr.left + 'px';
        nav.style.width = pr.width + 'px';
      }
    }

    function onScroll() {
      if (!ticking) {
        ticking = true;
        window.requestAnimationFrame(updateSticky);
      }
    }

    window.addEventListener('scroll', onScroll, { passive: true });
    window.addEventListener('resize', function () {
      if (stuck) releaseStuck();
      updateSticky();
    });
    updateSticky();

    var initial = (window.location.hash || '').replace('#', '');
    setActive(tabsById[initial] ? initial : sections[0].id);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();